<template>
  <div id="app" @touchmove.prevent>
    <!-- <div id="app" v-wechat-title="$route.meta.title"> -->
    <!-- <v-header :seller="seller"></v-header> -->
    <router-link class="weui-cells" to="/"></router-link>
	  <keep-alive :include="['userParkingFeeList','couponOrder','merChantParkingFee','plateInfo']">
		  <router-view />
	  </keep-alive>

  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
#app {
  height: 100%;
}
</style>
